import angular from 'angular';

import DateService from './date.service';
import DemandService from './demand.service';
import EmailService from './email.service';
import FaqService from './faq.service';
import GeoService from './geo.service';
import ItemService from './item.service';
import MessageCenterService from './message-center.service';
import OfferCampaignService from './offer-campaign.service';
import OfferMarketRestrictionService from './offer-market-restriction.service';
import OfferRequestItemService from './offer-request-item.service' ;
import OfferRequestService from './offer-request.service';
import OfferSidebarService from './offer-sidebar.service';
import OfferService from './offer.service';
import OrderBookingNoteService from './order-booking-note.service';
import OrderPaymentService from './order-payment.service';
import OrderSidebarService from './order-sidebar.service';
import OrderService from './order.service';
import PaginationService from './pagination.service';
import ProductEndUseService from './product-end-use.service';
import ProductService from './product.service';
import UiService from './ui.service';
import UserAcceptablePaymentTermService from './user-acceptable-payment-term.service';
import UserAddressService from './user-address.service';
import UserAdminMessageService from './user-admin-message.service';
import UserBankService from './user-bank.service';
import UserContactService from './user-contact.service';
import UserDeliveryTermService from './user-delivery-term.service';
import UserFreightRateService from './user-freight-rate.service';
import UserMarketRestrictionService from './user-market-restriction.service';
import UserProductEndUseService from './user-product-end-use.service';
import UserProductService from './user-product.service';
import UserRollMessageService from './user-roll-message.service';
import UserService from './user.service';
import MillService from './mill.service';
import NewsletterService from './newsletter.service';
import MessageService from './message.service';
import UserSidebarService from './user-sidebar.service';
import UserSpecialPaymentTermService from './user-special-payment-term.service';
import WebGlossaryService from './web-glossary.service';
import WebSourceService from './web-source.service';
import WebEventService from './web-event.service';
import WebNewService from './web-new.service';
import WebTopicService from './web-topic.service';

const app = angular.module('app.admin');

app.service('DateService', DateService);
app.service('DemandService', DemandService);
app.service('EmailService', EmailService);
app.service('FaqService', FaqService);
app.service('GeoService', GeoService);
app.service('ItemService', ItemService);
app.service('MessageCenterService', MessageCenterService);
app.service('OfferCampaignService', OfferCampaignService);
app.service('OfferMarketRestrictionService', OfferMarketRestrictionService);
app.service('OfferRequestItemService', OfferRequestItemService);
app.service('OfferRequestService', OfferRequestService);
app.service('OfferSidebarService', OfferSidebarService);
app.service('OfferService', OfferService);
app.service('OrderBookingNoteService', OrderBookingNoteService);
app.service('OrderPaymentService', OrderPaymentService);
app.service('OrderSidebarService', OrderSidebarService);
app.service('OrderService', OrderService);
app.service('PaginationService', PaginationService);
app.service('ProductEndUseService', ProductEndUseService);
app.service('ProductService', ProductService);
app.service('UiService', UiService);
app.service('UserAcceptablePaymentTermService', UserAcceptablePaymentTermService);
app.service('UserAddressService', UserAddressService);
app.service('UserAdminMessageService', UserAdminMessageService);
app.service('UserBankService', UserBankService);
app.service('UserContactService', UserContactService);
app.service('UserDeliveryTermService', UserDeliveryTermService);
app.service('UserFreightRateService', UserFreightRateService);
app.service('UserMarketRestrictionService', UserMarketRestrictionService);
app.service('UserProductEndUseService', UserProductEndUseService);
app.service('UserProductService', UserProductService);
app.service('UserRollMessageService', UserRollMessageService);
app.service('UserService', UserService);
app.service('MillService', MillService);
app.service('NewsletterService', NewsletterService);
app.service('MessageService', MessageService);
app.service('UserSidebarService', UserSidebarService);
app.service('UserSpecialPaymentTermService', UserSpecialPaymentTermService);
app.service('WebGlossaryService', WebGlossaryService);
app.service('WebSourceService', WebSourceService);
app.service('WebEventService', WebEventService);
app.service('WebNewService', WebNewService);
app.service('WebTopicService', WebTopicService);



// WEBPACK FOOTER //
// ./front/js/admin/services/index.js